"use client";

import { memo, useState } from "react";
import { WorkingText } from "@/components/ui/working-text";

export const LiveSessionTitle = memo(function LiveSessionTitle(props: {
  className?: string;
  title: string;
}) {
  const [previousTitle, setPreviousTitle] = useState(props.title);
  const [hasChanged, setHasChanged] = useState(false);

  // Existing titles stay still on mount; only subsequent title changes reveal.
  if (previousTitle !== props.title) {
    setPreviousTitle(props.title);
    setHasChanged(true);
  }

  return (
    <span className={props.className}>
      <WorkingText active={hasChanged}>{props.title}</WorkingText>
    </span>
  );
});
